export default function InstagramFeed() {
    return(
        <div className="elfsight-app-9303934f-22ae-4145-975a-a9291974cdce my-4"></div>
   )
}